import React from "react";
import { connect } from "react-redux";
import AuthNavBar from "../../allauth/AuthNavBar";
import { withRouter } from "../../utils/withRouter";
import { setFocusedMembership } from "../../store/api/calls";
import { withAuth } from "../../allauth/auth/withHooks";
import { CardHeader, Typography } from "@mui/material";

class ProfileScreen extends React.Component {

  handleCampaignSelection = (id) => {
    setFocusedMembership(id);
  };

  listRoles(roles = []) {
    return roles
      .map(role => role.name.substring(0, 1).toUpperCase() + role.name.substring(1))
      .join(', ');
  }

  renderMemberships = () => {
    const allCampaigns = this.props.memberships.map(({ campaign, roles }) => {
      return <CardHeader item
        data-campaignid={campaign.id}
        key={`select-campaign-${campaign.id}`}
        title={campaign.name}
        subheader={<React.Fragment>
          <Typography variant="body2" >
            {this.listRoles(roles)}
            <Typography variant="caption" style={{ marginLeft: '5px' }}  >
              - {new Date(campaign.created_at).toDateString()}
            </Typography>          
          </Typography>
          
        </React.Fragment>}
      />
    });

    if (allCampaigns.length === 0) {
      return <Typography variant="body1" color="text.secondary" >No campaign memberships found</Typography>
    }

    return <React.Fragment>
      <h5 className={"primary-text"} style={{ margin: '20px 0 0 0' }}>My Campaign Memberships</h5>
        {allCampaigns}
    </React.Fragment>
  }

  render() {
    return (
      <>
        <h5 className={"primary-text mb-1"}>Manage Profile</h5>
        <p style={{ margin: '0' }}>{this.props.user.username}</p>
        <p style={{ margin: '0 0 20px 0' }}>{this.props.user.email}</p>

        <AuthNavBar />

        {this.renderMemberships()}

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  memberships: state.permissions.memberships,
});


export default connect(
  mapStateToProps,
  null
)(withRouter(withAuth(ProfileScreen)));